class HomeCollections {
  constructor() {
    this.sections = document.querySelectorAll('[js-home-collections]');
    if (!this.sections.length) return;
    this.mouseY = window.innerHeight / 2;
    this.slots = [
      { offset: -3, className: 'slot-3' },
      { offset: -2, className: 'slot-2' },
      { offset: -1, className: 'slot-1' },
      { offset: 0, className: 'center' },
      { offset: 1, className: 'slot1' },
      { offset: 2, className: 'slot2' },
      { offset: 3, className: 'slot3' },
    ];
    this.init();
  }

  bindSection(section, idx) {
    const list = section.querySelector('[js-home-collections-list]');
    const sourceItems = Array.from(section.querySelectorAll('[js-home-collections-item]'));
    if (!list || !sourceItems.length) return;

    const MIN_ITEMS = 20;
    const itemMarkup = sourceItems.map((item) => item.outerHTML);
    const repeats = Math.max(1, Math.ceil(MIN_ITEMS / itemMarkup.length));
    const sourceMarkup = itemMarkup.join('').repeat(repeats);
    const state = {
      segmentHeight: 0,
      listHeight: 0,
      viewportHeight: 0,
      offset: 0,
      items: [],
    };

    const resetLens = () => {
      state.items.forEach((item) => {
        item.className = 'ird-home-collections__item';
        item.style.marginTop = '0px';
      });
    };

    const adjustGaps = (desiredGap = 8) => {
      const rects = state.items.map((item) => item.getBoundingClientRect());
      for (let index = 1; index < state.items.length; index += 1) {
        const currentGap = rects[index].top - rects[index - 1].bottom;
        const delta = desiredGap - currentGap;
        state.items[index].style.marginTop = `${delta}px`;
      }
    };

    const updateLens = () => {
      if (!state.items.length) return;

      let closestIndex = 0;
      let closestDist = Number.POSITIVE_INFINITY;

      state.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const centerY = rect.top + (rect.height / 2);
        const dist = Math.abs(this.mouseY - centerY);
        if (dist < closestDist) {
          closestDist = dist;
          closestIndex = index;
        }
      });

      resetLens();
      this.slots.forEach((slot) => {
        const index = closestIndex + slot.offset;
        if (state.items[index]) {
          state.items[index].classList.add(slot.className);
        }
      });
      adjustGaps();
    };

    const syncLayout = () => {
      list.style.transform = 'translate3d(-50%, 0, 0)';
      state.offset = 0;
      list.innerHTML = sourceMarkup.repeat(2);
      state.items = Array.from(list.querySelectorAll('[js-home-collections-item]'));
      state.listHeight = list.scrollHeight;
      state.segmentHeight = state.listHeight / 2;
      state.viewportHeight = section.clientHeight;
      updateLens();
    };

    const applyScrollPosition = (scrollValue) => {
      const sectionTopAbs = section.offsetTop;
      const sectionHeight = section.clientHeight;
      const startScroll = sectionTopAbs - window.innerHeight;
      const endScroll = sectionTopAbs + sectionHeight;
      const rawProgress = (scrollValue - startScroll) / Math.max(endScroll - startScroll, 1);
      const progress = Math.max(0, Math.min(1, rawProgress));
      state.offset = -(state.segmentHeight * progress);
      render();
    };

    const render = () => {
      list.style.transform = `translate3d(-50%, ${state.offset}px, 0)`;
      updateLens();
    };

    const updateFromScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset || 0;
      applyScrollPosition(scrollY);
    };

    window.addEventListener('resize', () => {
      this.mouseY = window.innerHeight / 2;
      syncLayout();
      updateFromScroll();
    });

    window.addEventListener('mousemove', (event) => {
      this.mouseY = event.clientY;
      updateLens();
    });

    const lenis = window.lenis;
    if (lenis && typeof lenis.on === 'function') {
      lenis.on('scroll', ({ scroll }) => {
        applyScrollPosition(scroll);
      });
    } else {
      window.addEventListener('scroll', updateFromScroll, { passive: true });
    }

    syncLayout();
    updateFromScroll();
    section.dataset.homeCollectionsReady = `${idx}`;
  }

  init() {
    this.sections.forEach((section, idx) => this.bindSection(section, idx));
  }
}

export default HomeCollections;
